// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalPortal_wrapper__AlBN4"};